<div *ngIf="dateRangeTypesList && dateRangeTypesList.length>0" class="flex flex-row justify-start items-center">
  <mat-form-field class="full-grow-no-shrink-no-basis" appearance="outline">
    <mat-label>Type</mat-label>
    <mat-select placeholder="Type" [(ngModel)]="dateRangeType" (selectionChange)="onDateRangeTypeChange($event)">
      <mat-option *ngFor="let rangeType of dateRangeTypesList" [value]="rangeType.id"
                  [ngStyle]="getTypeTextColor(rangeType)">
        {{rangeType.title}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


<div *ngIf="dateRangeType && !hideFiscalYearNote" class="selectFiscalYear flex flex-row">
  <p class="m-0">
    <strong>Please Note:</strong> Fiscal Quarters are based on a Fiscal Year End of
    <strong>{{currentFiscalDate | date: 'd MMM yyyy'}}</strong>
    <button mat-icon-button (click)="picker.open()" class="icon-dropdown-button m-l-10">
      <mat-icon>create</mat-icon>
    </button>
  </p>

  <mat-form-field style="visibility: hidden;width:0px;height:0px;line-height: 0;">
    <input matInput [matDatepicker]="picker" [matDatepickerFilter]="weekendsDatesFilter"
           (dateChange)="onFiscalDate($event)">
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>


<div *ngIf="dateRangeType" class="flex flex-row" style="padding-top:5px">
  <mat-form-field appearance="outline" class="m-r-20 full-grow-no-shrink-no-basis">
    <mat-label>From Date</mat-label>
    <input matInput [matDatepicker]="datePicker1" [ngModel]="startDate"
           placeholder="From Date" (dateChange)="onFromDate($event)" required>
    <mat-datepicker-toggle matSuffix [for]="datePicker1"></mat-datepicker-toggle>
    <mat-datepicker #datePicker1></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
    <mat-label>To Date</mat-label>
    <input matInput [matDatepicker]="datePicker2" [ngModel]="endDate"
           placeholder="To Date" (dateChange)="onToDate($event)" required>
    <mat-datepicker-toggle matSuffix [for]="datePicker2"></mat-datepicker-toggle>
    <mat-datepicker #datePicker2></mat-datepicker>
  </mat-form-field>
</div>
